module.exports = __webpack_public_path__ + "static/media/time-is-over.b58e7247.svg";